module.exports = __webpack_public_path__ + "media/images/mdlogo-black-e83e18ac858794563d289a00847f4bbf.png";